import { createSelector } from '@reduxjs/toolkit';
import { UID_NAME_TUPLES } from 'constants/dataSets';

import type { RootState } from '../../types/TStore';
import type IEnumResponse from '../dataSets/interfaces/IEnumResponse';

const valueChainMap = (state: RootState) => state.valueChainMap;

export const valueChainMapQueryParamsSelector = createSelector(
  [valueChainMap],
  ({ valueChainMapQueryParams }) => valueChainMapQueryParams,
);

export const currentCompanyMapTabSelector = createSelector(
  [valueChainMap],
  (state) => state.currentCompanyMapTab,
);

export const selectUidNameTuplesVC = createSelector(
  (data?:IEnumResponse) => data?.data,
  (data) => data?.reduce((acc, item) => {
    const isNamedRecord = item.name === UID_NAME_TUPLES.supplier
      || item.name === UID_NAME_TUPLES.balanceSheetAsset;
    const transformedEnum = item?.enum?.map(({ label, value, profitCentreUIDs }) => ({
      label: isNamedRecord ? label : value,
      value,
      profitCentreUIDs,
    }));
    return { ...acc, [item.name]: transformedEnum };
  }, {}),
);
